function maskMonthYear(value) {
  const ultimoCaracter = value.slice(-1)

  let valor = value.replace(/\D/g, '') // Remover caracteres no numéricos
  let formato = ''

  if (ultimoCaracter === '/') {
    if (valor.length == 1) valor = `0${value}`
  }

  if (valor.length >= 4) {
    formato += valor.substring(0, 4) + '/'
  } else {
    formato += valor
  }

  if (valor.length > 4) {
    formato += valor.substring(4, 6)
  }
  return formato
}

const validateMonthYear = (monthYear, minYear, maxYear) => {
  const digits = monthYear.replace(/\D/g, '')
  if (digits.length !== 6) return { valid: false, message: 'Ingresá un período válido (AAAA/MM)' }

  const month = parseInt(digits.slice(4, 6), 10)
  const year = parseInt(digits.slice(0, 4), 10)

  if (month < 1 || month > 12) {
    return { valid: false, message: 'Ingresá un mes válido (01-12)' }
  }

  if (minYear && year < minYear) {
    return { valid: false, message: `El año debe ser mayor o igual a ${minYear}.` }
  }
  if (maxYear && year > maxYear) {
    return { valid: false, message: `El año debe ser menor o igual a ${maxYear}.` }
  }

  return { valid: true }
}

const swapPeriodo = (periodo) => {
  if (!periodo) return periodo
  const [year, month] = periodo.split('-')

  if (year && month) {
    return `${month}-${year}`
  }
  return periodo
}

const adaptarPeriodo = (periodo) => {
  if (typeof periodo === 'number') {
    const periodoStr = periodo.toString().padStart(6, '0')
    return periodoStr.replace(/^(\d{4})(\d{2})$/, '$1-$2')
  }

  // Si ya es string
  if (typeof periodo === 'string') {
    const periodoStr = periodo.padStart(6, '0')

    if (periodoStr.match(/^\d{4}-\d{2}$/)) {
      return periodoStr
    }

    if (periodoStr.match(/^\d{6}$/)) {
      return periodoStr.replace(/^(\d{4})(\d{2})$/, '$1-$2')
    }

    if (periodoStr.match(/^\d{2}-\d{4}$/)) {
      const [month, year] = periodoStr.split('-')
      return `${year}-${month.padStart(2, '0')}`
    }
  }
  return periodo ? String(periodo) : periodo
}

export { maskMonthYear, validateMonthYear, swapPeriodo, adaptarPeriodo }
